import {defaultCountries, getActiveFormattingMask, guessCountryByPartialPhoneNumber} from 'react-international-phone';

const PHONE_MASK_CHAR = '.';
const PHONE_MASK_DIGIT_TOLERANCE = 1;
const DIAL_CODE_INDEX = 2;

export const getPhoneNumberAfterDialCodeSelection = (previousNumber: string, updatedNumber: string, selectedDialCode?: string): string => {
  if (selectedDialCode === undefined || updatedNumber !== `+${selectedDialCode}`) {
    return updatedNumber;
  }

  for (const country of defaultCountries) {
    const dialCode = `+${country[DIAL_CODE_INDEX]}`;
    if (previousNumber.startsWith(dialCode)) {
      return previousNumber.replace(dialCode, updatedNumber);
    }
  }

  return updatedNumber;
};

export const isValidPhoneNumber = (value: string): boolean => {
  const phoneNumberRegex = /^[0-9\s()+-]*$/;
  return phoneNumberRegex.test(value);
};

export const isCompletePhoneNumber = (value: string): boolean => {
  const {country, fullDialCodeMatch} = guessCountryByPartialPhoneNumber({phone: value});
  if (!country || !fullDialCodeMatch) {
    return false;
  }

  const mask = getActiveFormattingMask({phone: value, country});
  const maskDigitCount = (mask.match(new RegExp(`\\${PHONE_MASK_CHAR}`, 'g')) ?? []).length;
  const nationalDigitCount = value.replace(/\D/g, '').length - country.dialCode.length;

  return nationalDigitCount >= maskDigitCount - PHONE_MASK_DIGIT_TOLERANCE && nationalDigitCount <= maskDigitCount;
};
